// extracted by mini-css-extract-plugin
export default {"mainContainer":"AdvanceSetting_mainContainer__e69G5","column":"AdvanceSetting_column__E43ra","button":"AdvanceSetting_button__nFCiy","icon":"AdvanceSetting_icon__oNGt4"};